import React from "react";
import { Message } from "react-message-context";
import { Action, Alert, getLocale } from "@op/opds.opux";
import { observer } from "mobx-react";
import RestStore from "../../stores/RestStore";
import { getRedirectUrl } from "../../utils/constants";

const Info = observer(() => {
  const { customerType } = RestStore;

  return (
    <div className="cff-info">
      <p>
        <Message id="info.body" />
      </p>
      <Alert>
        <p>
          <Message id="info.alert.row.1" />
        </p>
        <p>
          <Action href={getRedirectUrl(customerType, getLocale())}>
            <Message id="info.alert.row.2" />
          </Action>
        </p>
      </Alert>
    </div>
  );
});

export default Info;
